import React from "react";
import { Line, FormGroup, LeftText, RightText } from "./styles";

interface Props {
  leftText: string;
  rightText: string | number;
  money?: boolean;
}

export const ModalItem: React.FC<Props> = ({
  leftText,
  rightText,
  money
}) => {

  function ToMoney(Valor: number){
    return(
      Valor.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    );
  }
  
  return (
    <FormGroup>
      <Line>
        <LeftText>{leftText}</LeftText>

        <RightText>{money && typeof rightText === "number" ? "R$ " + ToMoney(rightText) : rightText}</RightText>
      </Line>
    </FormGroup>
  );
}